"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = _interopRequireDefault(require("./utils"));
var _reactInputPosition = _interopRequireWildcard(require("@stepkillah/react-input-position"));
var _SideBySideRenderer = _interopRequireDefault(require("./SideBySideRenderer"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SideBySideMagnifier = function SideBySideMagnifier(_ref) {
  var _ref$imageSrc = _ref.imageSrc,
    imageSrc = _ref$imageSrc === void 0 ? '' : _ref$imageSrc,
    _ref$largeImageSrc = _ref.largeImageSrc,
    largeImageSrc = _ref$largeImageSrc === void 0 ? '' : _ref$largeImageSrc,
    _ref$imageAlt = _ref.imageAlt,
    imageAlt = _ref$imageAlt === void 0 ? '' : _ref$imageAlt,
    _ref$overlayOpacity = _ref.overlayOpacity,
    overlayOpacity = _ref$overlayOpacity === void 0 ? 0.5 : _ref$overlayOpacity,
    _ref$overlayBoxOpacit = _ref.overlayBoxOpacity,
    overlayBoxOpacity = _ref$overlayBoxOpacit === void 0 ? 0.8 : _ref$overlayBoxOpacit,
    _ref$overlayBackgroun = _ref.overlayBackgroundColor,
    overlayBackgroundColor = _ref$overlayBackgroun === void 0 ? '#000' : _ref$overlayBackgroun,
    _ref$overlayBoxColor = _ref.overlayBoxColor,
    overlayBoxColor = _ref$overlayBoxColor === void 0 ? '#fff' : _ref$overlayBoxColor,
    _ref$overlayBoxImage = _ref.overlayBoxImage,
    overlayBoxImage = _ref$overlayBoxImage === void 0 ? '' : _ref$overlayBoxImage,
    _ref$overlayBoxImageS = _ref.overlayBoxImageSize,
    overlayBoxImageSize = _ref$overlayBoxImageS === void 0 ? '' : _ref$overlayBoxImageS,
    _ref$cursorStyle = _ref.cursorStyle,
    cursorStyle = _ref$cursorStyle === void 0 ? 'crosshair' : _ref$cursorStyle,
    alwaysInPlace = _ref.alwaysInPlace,
    _ref$transitionSpeed = _ref.transitionSpeed,
    transitionSpeed = _ref$transitionSpeed === void 0 ? 0.4 : _ref$transitionSpeed,
    _ref$transitionSpeedI = _ref.transitionSpeedInPlace,
    transitionSpeedInPlace = _ref$transitionSpeedI === void 0 ? 0.4 : _ref$transitionSpeedI,
    renderOverlay = _ref.renderOverlay,
    className = _ref.className,
    style = _ref.style,
    _ref$onImageLoad = _ref.onImageLoad,
    onImageLoad = _ref$onImageLoad === void 0 ? _utils["default"].noop : _ref$onImageLoad,
    _ref$onLargeImageLoad = _ref.onLargeImageLoad,
    onLargeImageLoad = _ref$onLargeImageLoad === void 0 ? _utils["default"].noop : _ref$onLargeImageLoad,
    switchSides = _ref.switchSides,
    onZoomStart = _ref.onZoomStart,
    onZoomEnd = _ref.onZoomEnd,
    _ref$fillAvailableSpa = _ref.fillAvailableSpace,
    fillAvailableSpace = _ref$fillAvailableSpa === void 0 ? true : _ref$fillAvailableSpa,
    _ref$fillAlignTop = _ref.fillAlignTop,
    fillAlignTop = _ref$fillAlignTop === void 0 ? false : _ref$fillAlignTop,
    _ref$fillGapLeft = _ref.fillGapLeft,
    fillGapLeft = _ref$fillGapLeft === void 0 ? 0 : _ref$fillGapLeft,
    _ref$fillGapRight = _ref.fillGapRight,
    fillGapRight = _ref$fillGapRight === void 0 ? 0 : _ref$fillGapRight,
    _ref$fillGapTop = _ref.fillGapTop,
    fillGapTop = _ref$fillGapTop === void 0 ? 0 : _ref$fillGapTop,
    _ref$fillGapBottom = _ref.fillGapBottom,
    fillGapBottom = _ref$fillGapBottom === void 0 ? 0 : _ref$fillGapBottom,
    _ref$inPlaceMinBreakp = _ref.inPlaceMinBreakpoint,
    inPlaceMinBreakpoint = _ref$inPlaceMinBreakp === void 0 ? 0 : _ref$inPlaceMinBreakp,
    _ref$zoomContainerBor = _ref.zoomContainerBorder,
    zoomContainerBorder = _ref$zoomContainerBor === void 0 ? 'none' : _ref$zoomContainerBor,
    _ref$zoomContainerBox = _ref.zoomContainerBoxShadow,
    zoomContainerBoxShadow = _ref$zoomContainerBox === void 0 ? 'none' : _ref$zoomContainerBox,
    _ref$mouseActivation = _ref.mouseActivation,
    mouseActivation = _ref$mouseActivation === void 0 ? _reactInputPosition.MOUSE_ACTIVATION.HOVER : _ref$mouseActivation,
    _ref$touchActivation = _ref.touchActivation,
    touchActivation = _ref$touchActivation === void 0 ? _reactInputPosition.TOUCH_ACTIVATION.TOUCH : _ref$touchActivation;
  return /*#__PURE__*/_react["default"].createElement(_reactInputPosition["default"], {
    style: style,
    className: className,
    touchActivationMethod: touchActivation,
    mouseActivationMethod: mouseActivation,
    onActivate: onZoomStart,
    onDeactivate: onZoomEnd,
    trackItemPosition: true,
    linkItemToActive: true
  }, /*#__PURE__*/_react["default"].createElement(_SideBySideRenderer["default"], {
    imageSrc: imageSrc,
    largeImageSrc: largeImageSrc,
    imageAlt: imageAlt,
    overlayOpacity: overlayOpacity,
    overlayBoxOpacity: overlayBoxOpacity,
    overlayBackgroundColor: overlayBackgroundColor,
    overlayBoxColor: overlayBoxColor,
    overlayBoxImage: overlayBoxImage,
    overlayBoxImageSize: overlayBoxImageSize,
    alwaysInPlace: alwaysInPlace,
    transitionSpeed: transitionSpeed,
    transitionSpeedInPlace: transitionSpeedInPlace,
    renderOverlay: renderOverlay,
    cursorStyle: cursorStyle,
    onImageLoad: onImageLoad,
    onLargeImageLoad: onLargeImageLoad,
    switchSides: switchSides,
    fillAvailableSpace: fillAvailableSpace,
    fillAlignTop: fillAlignTop,
    fillGapLeft: fillGapLeft,
    fillGapRight: fillGapRight,
    fillGapTop: fillGapTop,
    fillGapBottom: fillGapBottom,
    inPlaceMinBreakpoint: inPlaceMinBreakpoint,
    zoomContainerBorder: zoomContainerBorder,
    zoomContainerBoxShadow: zoomContainerBoxShadow
  }));
};
SideBySideMagnifier.propTypes = {
  imageSrc: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  largeImageSrc: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  imageAlt: _propTypes["default"].string,
  overlayOpacity: _propTypes["default"].number,
  overlayBoxOpacity: _propTypes["default"].number,
  overlayBackgroundColor: _propTypes["default"].string,
  overlayBoxColor: _propTypes["default"].string,
  overlayBoxImage: _propTypes["default"].string,
  overlayBoxImageSize: _propTypes["default"].string,
  cursorStyle: _propTypes["default"].string,
  alwaysInPlace: _propTypes["default"].bool,
  transitionSpeed: _propTypes["default"].number,
  transitionSpeedInPlace: _propTypes["default"].number,
  renderOverlay: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  onImageLoad: _propTypes["default"].func,
  onLargeImageLoad: _propTypes["default"].func,
  fillAvailableSpace: _propTypes["default"].bool,
  fillAlignTop: _propTypes["default"].bool,
  fillGapLeft: _propTypes["default"].number,
  fillGapRight: _propTypes["default"].number,
  fillGapTop: _propTypes["default"].number,
  fillGapBottom: _propTypes["default"].number,
  inPlaceMinBreakpoint: _propTypes["default"].number,
  zoomContainerBorder: _propTypes["default"].string,
  zoomContainerBoxShadow: _propTypes["default"].string,
  mouseActivation: _propTypes["default"].string,
  touchActivation: _propTypes["default"].string
};
var _default = exports["default"] = SideBySideMagnifier;